import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  row: {
    borderRadius: 8,
    '&:hover': {
      '& #kebab': {
        color: '#263057'
      }
    }
  },
  itemuser: {
    height: 44,
    fontSize: 14,
    fontWeight: 'bold',
    color: '#6e7a76',
    textAlign: 'start',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    paddingLeft: 10
  },
  itemstatus: {
    height: 44,
    color: '#6e7a76',
    textAlign: 'center',
    '&:hover': {
      color: '#026873'
    }
  },
  confirmButton: {
    height: 28,
    width: 115,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: '1%',
    marginRight: 3,
    marginTop: 10,
    cursor: 'pointer',
    background: '#f9f9f9',

    '&:hover': {
      backgroundColor: '#f2f2f2'
    },
    border: '2px solid #263057',
    borderRadius: '23px'
  },
  confirmButtonTypography: {
    fontFamily: 'Raleway',
    fontSize: '0.9em',
    letterSpacing: '0.05em',
    color: '#028B7E'
  },
  buttons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end'
  },
  hoverButton: {
    color: '#706E6F',
    '&:hover': {
      color: '#026873'
    }
  },
  hoverButtonDelete: {
    color: '#706E6F',
    '&:hover': {
      color: '#AD0707'
    }
  },
  itemName: {
    height: 44,
    fontSize: 13,
    fontWeight: 'bold',
    color: '#6e7a76',
    textAlign: 'start',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  itemSize: {
    height: 44,
    fontSize: 13,
    fontWeight: 'bold',
    color: '#6e7a76',
    textAlign: 'start',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    '@media all and (max-width: 1200px)': {
      display: 'none'
    }
  },
  itemDate: {
    height: 44,
    fontSize: 13,
    fontWeight: 'bold',
    color: '#6e7a76',
    textAlign: 'center',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    '@media all and (max-width: 1200px)': {
      display: 'none'
    }
  },

  kebab: {
    color: '#B3B3B3'
  }
}))

export default useStyles
